module.exports = __webpack_public_path__ + "static/media/wind-turbine.6ffffee4.svg";